import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=354382d1&scoped=true"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"
import style0 from "./Thankyou.vue?vue&type=style&index=0&id=354382d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354382d1",
  null
  
)

export default component.exports